import { useState } from "react";
import "./Navigation.scss";

const menuItems = [
  { label: "Főoldal", target: "home" },
  { label: "Történetünk", target: "story" },
  { label: "Menetrend", target: "schedule" },
  { label: "Helyszín", target: "venue" },
  { label: "Szállások", target: "accommodation" },
  { label: "Továbbá", target: "transfer" },
//   { label: "Dress code", target: "dress-code" },
//   { label: "Egy kis plusz", target: "extras"},
  { label: "Visszajelzés", target: "rsvp"},
  { label: "Kapcsolat", target: "contact" }
];

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (target: string) => {
    document.getElementById(target)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    setIsOpen(false);
  };

  return (
    <nav className="navigation" aria-label="Fő navigáció">
      <div className="navigation-inner">
        <button
          type="button"
          className="navigation-logo"
          onClick={() => scrollToSection("home")}
          aria-label="Ugrás az oldal tetejére"
        >
          V <span>&amp;</span> R
        </button>

        <button
          type="button"
          className={`navigation-toggle ${isOpen ? "is-open" : ""}`}
          onClick={() => setIsOpen((current) => !current)}
          aria-expanded={isOpen}
          aria-controls="main-navigation-menu"
          aria-label={isOpen ? "Menü bezárása" : "Menü megnyitása"}
        >
          <span />
          <span />
          <span />
        </button>

        <div
          id="main-navigation-menu"
          className={`navigation-menu ${isOpen ? "is-open" : ""}`}
        >
          {menuItems.map((item) => (
            <button
              type="button"
              key={item.target}
              onClick={() => scrollToSection(item.target)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};